// extracted by mini-css-extract-plugin
export const menu = "header-module--menu--2Uxwi";
export const active = "header-module--active--1JOPQ";